export default __webpack_public_path__ + "static/media/alarm.eb3c99d1.mp3";